import { useTranslation } from 'react-i18next'
import { ReactComponent as IconLinkedScope } from '../../assets/svg/linkedscope-icon.svg'
import './appLoadingIndicator.css'

export default function AppLoadingIndicator() {
  const { t } = useTranslation('commonTranslation', { useSuspense: false })

  return (
    <div className="loading-container app-loading-indicator" role="status" aria-label={t('routeLoading.loading')}>
      <IconLinkedScope className="loading-icon" aria-hidden="true" />
    </div>
  )
}
